button {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 0;
  border: none;
  background: none;
  cursor: pointer;
  border-radius: 50%;
  pos-picture {
    --width: 40px;
    --height: 40px;
    --border-radius: 50%;
  }
  sl-avatar {
    --size: 40px;
  }
}

sl-dropdown {
  display: block;
}
